// extracted by mini-css-extract-plugin
module.exports = {"panel":"LoginLeftSection_panel__2tSYR","image":"LoginLeftSection_image__LCDvD"};